const LOGGING_EVENTS = {
  CANCEL_ORDER_CLICK: 'cancel_order_click',
  CANCEL_ORDER_SUCCESS: 'cancel_order_success',
  REQUEST_CALL_FAILURE: 'request_call_failure',
  CONNECTION_RESTORED: 'connection_restored',
  LEAVING_CHECKOUT: 'leaving_checkout',
  NAFATH_REQUEST_EXPIRED: 'nafath_request_expired',
  IVR_CONFIRMATION: 'ivr_confirmation',
  IVR_REQUEST_EXPIRED: 'ivr_request_expired',
  IVR_PROCESSING: 'ivr_processing',
  IVR_SUCCESS: 'ivr_success',
  IVR_RETRY: 'ivr_retry',
  REDIRECT_TO_MERCHANT: 'redirect_to_merchant',
  REDIRECT_TO_PAYMENT_SERVICE: 'redirect_to_payment_service',
  REDIRECT_TO_KYC: 'redirect_to_kyc',
  KYC_FETCH: 'fetching_kyc_data',
  KYC_ERROR: 'kyc_error',
  SUBMIT_DATA_ERROR: 'submit_data_error',
  MERCHANT_ORDER_DECLINED: 'merchant_order_declined',
  KYC_SUCCESSFUL_PAGE_VIEWED: 'kyc_successful_page_viewed',
  INIT_KYC_SESSION: 'init_kyc_session',
  ID_VERIFICATION_PAGE_LOADED: 'id_verification_page_loaded',
  ID_VERIFICATION_SUBMIT_CLICKED: 'id_verification_submit_clicked',
  ID_VERIFICATION_NAFATH_SKIP_CLICKED:
    'id_verfication_submit_nafath_skip_clicked',
  ID_VERIFICATION_NAFATH_POPUP_LOADED: 'id_verification_nafath_popup_viewed',
  ID_VERIFICATION_NAFATH_PAGE_LOADED: 'id_verification_nafath_page_viewed',
  ID_VERIFICATION_OPEN_NAFATH_APP_CLICKED:
    'id_verification_open_nafath_app_clicked',
  ID_VERIFICATION_NAFATH_VERIFICATION_STATUS:
    'id_verification_nafath_verification_status_polling',
  ID_VERIFICATION_NAFATH_RETRY_CLICKED: 'id_verification_nafath_retry_clicked',
  ID_VERIFICATION_NAFATH_SUCCESS: 'id_verification_nafath_success',
  ID_VERIFICATION_RETRY_LIMIT_REACHED: 'id_verification_retry_limit_reached',
  KYC_FINISHED_REDIRECTING_CHECKOUT: 'kyc_finished_redirecting_to_checkout',
  ID_VERIFICATION_OTP_PAGE_VIEWED: 'id_verification_otp_screen_viewed',
  KYC_FINISH_PAGE_VIEWED: 'kyc_finish_screen_viewed',
  KYC_DECLINED_PAGE_VIEWED: 'kyc_declined_screen_viewed',
  KYC_FAILURE_PAGE_VIEWED: 'kyc_failure_page_viewed',
  KYC_CREDIT_UNDERWRITING_PAGE_VIEWED: 'kyc_credit_underwriting_screen_viewed',
  ID_VERIFICATION_CREDIT_EVALUATION_WAITING_PAGE_LOADED:
    'id_verification_credit_evaluation_waiting_screen_viewed',
  KYC_SEON_SESSION_FAILURE: 'kyc_seon_session_failure',
  KYC_SESSION_ID_MISSING: 'kyc_session_id_missing',
  ID_VERFICATION_ERROR_VIEWED: 'id_verification_error_viewed',
  ID_VERIFICATION_INVALID_STEP: 'id_verification_invalid_step',
  KYC_API_REQUEST: 'kyc_api_request',
}

export default LOGGING_EVENTS
